<template>
  <section class="promo-section" v-bind:class="{ 'gray-light-bg' : isGray }">

  </section>
</template>


<script>
export default {
  name: "Promo",
  props: {
    showDesc: {
      type: Boolean,
      default: false
    },
    isGray: {
      type: Boolean,
      default: false
    },
  }
};
</script>

<style>

  .home-img-title{
      width: 5.5em;
  }

  .pb-2{
      text-align: center;
  }

</style>